import ProfileBar from './ProfileBar';

export default ProfileBar;
